"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = _interopRequireDefault(require("@eig-builder/core-ui/TextField"));

var _KeyboardArrowUp = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowUp"));

var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));

var _InputAdornment = _interopRequireDefault(require("@eig-builder/core-ui/InputAdornment"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _index = require("./index");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  > div,\n  input:hover {\n    cursor: pointer !important;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ComboBoxField = (0, _styledComponents["default"])(_TextField["default"])(_templateObject());

var ComboBoxInput = function ComboBoxInput(_ref) {
  var label = _ref.label;

  var _useComboBoxContext = (0, _index.useComboBoxContext)(),
      setAnchorRef = _useComboBoxContext.setAnchorRef,
      setOpen = _useComboBoxContext.setOpen,
      selected = _useComboBoxContext.selected,
      open = _useComboBoxContext.open;

  var value = selected ? Array.isArray(selected) ? selected.join(', ') : selected : 'none';
  return /*#__PURE__*/_react["default"].createElement(ComboBoxField, {
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: "data-grid-combo-box-input",
    dataElementId: "data-grid-combo-box-input",
    variant: "outlined",
    onClick: function onClick(e) {
      setAnchorRef(e.currentTarget);
      setOpen(true);
    },
    value: value.key,
    InputProps: {
      readOnly: true,
      startAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "start"
      }, label || ''),
      endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], null, open ? /*#__PURE__*/_react["default"].createElement(_KeyboardArrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_KeyboardArrowUp["default"], null))
    }
  });
};

ComboBoxInput.propTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string])
};
var _default = ComboBoxInput;
exports["default"] = _default;